module.exports = __webpack_public_path__ + "static/media/32.7f310644.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/32.svg
// module id = 422
// module chunks = 14